import { useMutation, useQuery } from '@tanstack/react-query';

import { NotificationRequest } from '../models/NotificationRequest';
import { NotificationResponse } from '../models/NotificationResponse';
import axiosClient from '../axiosBearerClient';

export const useGetNotifications = () => {
  const { isFetching, error, data, isError, refetch } = useQuery({
    queryKey: ['notifications'],
    retry: false,
    enabled: false,
    queryFn: async () => {
      return await axiosClient.get<NotificationResponse[]>(`/notifications`);
    },
  });

  return {
    isFetching,
    error,
    isError,
    data,
    refetch,
  };
};

export const usePathNotification = () => {
  const { isPending, error, data, isError, mutateAsync } = useMutation({
    retry: false,
    mutationFn: async ({ id, notification }: { id: string; notification: NotificationRequest }) => {
      return await axiosClient.patch<NotificationRequest>(`/notifications/${id}`, notification);
    },
  });

  return {
    isPending,
    error,
    isError,
    data,
    mutateAsync,
  };
};

export const useDeleteNotification = () => {
  const { isPending, error, data, isError, mutateAsync } = useMutation({
    retry: false,
    mutationFn: async (id: string) => {
      return await axiosClient.delete(`/notifications/${id}`);
    },
  });

  return {
    isPending,
    error,
    isError,
    data,
    mutateAsync,
  };
};
